export enum OriginMessageError {
  BACKEND = 'backend',
  FRONTEND = 'frontend',
}
